import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=b22ea862&scoped=true"
import script from "./position-list.vue?vue&type=script&lang=js"
export * from "./position-list.vue?vue&type=script&lang=js"
import style0 from "./position-list.vue?vue&type=style&index=0&id=b22ea862&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22ea862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22ea862')) {
      api.createRecord('b22ea862', component.options)
    } else {
      api.reload('b22ea862', component.options)
    }
    module.hot.accept("./position-list.vue?vue&type=template&id=b22ea862&scoped=true", function () {
      api.rerender('b22ea862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule_report/form/position-list.vue"
export default component.exports